import React from "react";
import { NavLink, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const getCategoryName = (category: string) => {
    const words = category.split("-");
    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase() + words[0].slice(1);
    } else {
        const firstWord = words[0];
        const restOfWords = words.slice(1).join(" ");
        return firstWord.charAt (0).toUpperCase () + firstWord.slice (1) + " " + restOfWords;
    }
}

interface OrderMainFoodPathProps {
    path: string[];
    component: string;
}

const ProfilePath: React.FC<OrderMainFoodPathProps> = (props) => {
    const { t } = useTranslation();
    const {category, subcategory} = useParams();

    return (
        <div className="profilePath__container">
            <div className="profilePath__container-path-wrap">
                <NavLink to="/">{t('categories.mainPage')}</NavLink>
                {
                    props.path.map((item, index) => (
                        <div key={index}>
                            {
                                item === props.component ? (
                                <>
                                    <span className="profilePath__container-path-symbol">{`>`}</span>
                                    <NavLink to={`/${props.component.toLowerCase().replace(/\s/g, "-")}`}>
                                        {t(`categories.${props.component.toLowerCase()}`)}
                                    </NavLink>
                                </>
                                ) : (
                                    <>
                                        {
                                            item !== '' && (
                                                <>
                                                    <span className="profilePath__container-path-symbol">{`>`}</span>
                                                    <NavLink
                                                      to={`/${props.component.toLowerCase().replace(/\s/g, "-")}/${item.toLowerCase().replace(/\s/g, "-")}`}
                                                    >
                                                        {t(`categories.${item.toLowerCase()}`)}
                                                    </NavLink>
                                                    {
                                                        subcategory && (
                                                            <>
                                                                <span className="profilePath__container-path-symbol">{`>`}</span>
                                                                <NavLink
                                                                  to={`/${props.component.toLowerCase().replace(/\s/g, "-")}/${item.toLowerCase().replace(/\s/g, "-")}/${subcategory.toLowerCase().replace(/\s/g, "-")}`}
                                                                >
                                                                    {/* {getCategoryName(subcategory)} */}
                                                                    {
                                                                        t(`categories.${subcategory.toLowerCase()}`)
                                                                    }
                                                                </NavLink>
                                                            </>
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ProfilePath;